module.exports = __webpack_public_path__ + "static/media/1033160.31f25ea9.jpg";